import React from 'react';
import styled from 'styled-components';
import { breakpoints } from 'constant/style';
import ImageComponent from 'components/Image';
import { getPriceWithCurrency } from 'utils/library';

interface MenuItemProps {
  title: string;
  description: string;
  price: string;
  image: string;
  currency: string;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const MenuItem = ({ title, description, price, image, currency, onClick }: MenuItemProps) => {
  const truncate = (input: string) => {
    if (input?.length > 100) {
      return input.substring(0, 100) + '...';
    }
    return input;
  };

  return (
    <MenuItemWrap onClick={onClick}>
      <div className="menu-list-item-desk">
        <div className="menu-content">
          <h6>{title}</h6>
          <p>{truncate(description)}</p>
          <p className="price-text">{getPriceWithCurrency(price, { decimalPlaces: 2, currency })}</p>
        </div>
        {image && (
          <div className="image-container">
            <ImageComponent className="menu-img" src={image} />
          </div>
        )}
      </div>
      <div className="menu-list-item-res">
        {image && <ImageComponent className="menu-img" src={image} height={150} width={150} />}
        <h6>{title}</h6>
        <h6 className="price-text">{getPriceWithCurrency(price, { decimalPlaces: 2, currency })}</h6>
      </div>
    </MenuItemWrap>
  );
};

export default MenuItem;

const MenuItemWrap = styled.div`
  .menu-list-item-desk {
    border: 1px solid var(--grey-light);
    box-sizing: border-box;
    border-radius: 10px;
    height: 150px;
    cursor: pointer;

    flex-direction: row;
    display: none;

    @media (min-width: ${breakpoints.tablet}) {
      display: flex;
    }

    .menu-content {
      padding: 10px;
      width: 65%;

      .price-text {
        color: var(--orange);
        font-weight: bold;
      }
    }

    .image-container {
      width: 35%;
    }

    .menu-img {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .menu-list-item-res {
    display: blcok;

    .menu-img {
      width: 100%;
      object-fit: cover;
      border-radius: 10px;
      margin-bottom: 10px;
    }

    .price-text {
      color: var(--orange);
    }

    @media (min-width: ${breakpoints.tablet}) {
      display: none;
    }
  }
`;
